import { render } from "./CerrrarGrupo.vue?vue&type=template&id=294a2c5e&scoped=true"
import script from "./CerrrarGrupo.vue?vue&type=script&lang=js"
export * from "./CerrrarGrupo.vue?vue&type=script&lang=js"

import "./CerrrarGrupo.vue?vue&type=style&index=0&id=294a2c5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294a2c5e"]])

export default __exports__